import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const LikeChatFaceYoga = lazyWithPreload(
  () => import('./LikeChatFaceYoga'),
)
